import { useTranslation } from 'react-i18next'
import { Form, Input, Button, Alert } from 'antd'
import { submitFormButton } from '../../styles/AuthStyles'

type EnterCodeFormValues = {
  code: string
}

type EnterCodeFormProps = {
  onFinish: (values: EnterCodeFormValues) => void
  loading: boolean
  error?: string
}

export const EnterCodeForm = ({ onFinish, loading, error }: EnterCodeFormProps) => {
  const { t } = useTranslation()
  return (
    <Form<EnterCodeFormValues>
      name='sendcode'
      layout='vertical'
      onFinish={onFinish}
    >
      {error && (
        <Alert
          data-testid='enter-code-error-alert'
          title={error}
          type='error'
          showIcon
          style={{ marginBottom: '16px' }}
          closable
        />
      )}

      <Form.Item
        name='code'
        className='font-medium'
        style={{ display: 'flex', justifyContent: 'center' }}
        rules={[
          { required: true, message: t('enter_code_required') },
          { pattern: /^\d{6}$/, message: t('enter_code_must_be_6_digits') },
        ]}
      >
        <Input.OTP
          data-testid='enter-code-otp-input'
          id='verifycode'
          style={{ textAlign: 'center', maxWidth: '280px' }}
          size='large'
          length={6}
        />
      </Form.Item>

      <Form.Item>
        <Button
          data-testid='enter-code-submit-button'
          type='primary'
          htmlType='submit'
          size='middle'
          style={submitFormButton}
          loading={loading}
        >
          {t('verify_cta')}
        </Button>
      </Form.Item>
    </Form>
  )
}
